module.exports = __webpack_public_path__ + "static/media/IMG_7837.bd4ed975.JPG";